// ============================================================
// RKF BRAND CONFIG — edit ticker text, links and emails here.
// ============================================================

// Brand logo (cut from the uploaded artwork, transparent background).
// Black version for light surfaces, white version for dark surfaces.
export const LOGO_URL = "/brand/rkf-logo-black.png";
export const LOGO_WHITE_URL = "/brand/rkf-logo-white.png";

export const CAMPAIGN_FILM_URL =
  "https://framerusercontent.com/assets/uwXmiSS3mEiRjQLkOeSJLDdDc.mp4";

const ASSETS = "https://customer-assets-jai6qajn.emergentagent.net/job_rkf-preview/artifacts";

export const IMG = {
  modelDP: `${ASSETS}/d58230ad5fc301f5_IMG_5446.JPG.webp`,
  modelAngel: `${ASSETS}/ccf52889158a64f2_IMG_5449.JPG.webp`,
  editorial: `${ASSETS}/a403983e471b4429_IMG_2759.JPG.webp`,
};

// Tee(s) shown on the homepage under "TEES" — always a single tee so visitors click TEES to see all.
export const HOME_TEE_SLUGS = ["different-personalities-tee"];

// TICKER TEXT — replace this single string to change the marquee everywhere.
export const TICKER_TEXT =
  "THEY TOLD US MONEY COULDN’T BUY HAPPINESS. SO WE BOUGHT EVERYTHING ELSE. WE GREW UP AROUND BEAUTIFUL THINGS AND LEARNED EARLY THAT BEAUTY HAS AN EXPIRATION DATE. THE FAST CARS. THE LATE NIGHTS. THE EMPTY BOTTLES. THE PEOPLE WHO WERE HERE AND THEN WEREN’T. WE CALLED IT LIVING BECAUSE WE DIDN’T HAVE A BETTER WORD FOR IT. YOUTH WAS NEVER MEANT TO LAST. NEITHER WAS FAME. NEITHER WAS FORTUNE. EVERYTHING EVENTUALLY ENDS UP IN A BOX, IN A FRAME, OR IN SOMEONE ELSE’S MEMORY. RICH KIDS FUNERAL IS A MEMORIAL TO THE LIFE WE REFUSED TO LIVE QUIETLY.";

export const MANIFESTO = TICKER_TEXT;

export const INSTAGRAM_HANDLE = "richkidsfuneral.in";
export const INSTAGRAM_URL = `https://www.instagram.com/${INSTAGRAM_HANDLE}/`;
export const CONTACT_EMAIL = "info@richkidsfuneral.com";

export const MENU_GROUPS = [
  {
    title: "TOPS",
    links: [
      { label: "TEES", to: "/tees" },
      { label: "SHIRTS", to: "/shirts" },
      { label: "HOODIES", to: "/hoodies" },
      { label: "JACKETS", to: "/jackets" },
    ],
  },
  {
    title: "BOTTOMS",
    links: [
      { label: "SHORTS", to: "/shorts" },
      { label: "SWEATS", to: "/sweats" },
      { label: "PANTS", to: "/pants" },
    ],
  },
  {
    title: "HEADGEAR",
    links: [
      { label: "BEANIES", to: "/beanies" },
      { label: "CAPS", to: "/caps" },
    ],
  },
  {
    title: "925 ACCESSORIES",
    links: [
      { label: "BRACELETS", to: "/bracelets" },
      { label: "WALLET CHAINS", to: "/wallet-chains" },
      { label: "MONEY CLIPPER", to: "/money-clipper" },
      { label: "LIGHTER COVER", to: "/lighter-cover" },
    ],
  },
];

export const COLLECTION_ROUTES = [
  { path: "/all-products", category: null, title: "ALL PRODUCTS" },
  { path: "/tees", category: "tees", title: "TEES" },
  { path: "/shirts", category: "shirts", title: "SHIRTS" },
  { path: "/hoodies", category: "hoodies", title: "HOODIES" },
  { path: "/jackets", category: "jackets", title: "JACKETS" },
  { path: "/shorts", category: "shorts", title: "SHORTS" },
  { path: "/sweats", category: "sweats", title: "SWEATS" },
  { path: "/pants", category: "pants", title: "PANTS" },
  { path: "/beanies", category: "beanies", title: "BEANIES" },
  { path: "/caps", category: "caps", title: "CAPS" },
  { path: "/bracelets", category: "bracelets", title: "BRACELETS" },
  { path: "/wallet-chains", category: "wallet-chains", title: "WALLET CHAINS" },
  { path: "/money-clipper", category: "money-clipper", title: "MONEY CLIPPER" },
  { path: "/lighter-cover", category: "lighter-cover", title: "LIGHTER COVER" },
];

// Prices are stored in INR. Display: "Rs. 15,000.00 INR"
export const money = (n) =>
  "Rs. " +
  Number(n).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }) +
  " INR";

export const FREE_SHIPPING_FROM = 20000;
export const FLAT_SHIPPING = 500;
export const shippingFor = (subtotal) =>
  subtotal >= FREE_SHIPPING_FROM ? 0 : FLAT_SHIPPING;
